<div class="overlay" *ngIf="loaderService.loading$ | async">
    <div class="center">
        <mat-spinner customSpinner color="#fff"></mat-spinner>
    </div>
</div>